var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [_vm._v("Filters")]),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c("li", [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.BodyID,
                          expression: "value.BodyID",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "BodyID",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(
                      _vm.PartsCatalogBodyIDTypeEnum,
                      function (BodyID, propertyName, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: propertyName } },
                          [_vm._v(" " + _vm._s(BodyID) + " ")]
                        )
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.value.BodyType,
                          expression: "value.BodyType",
                        },
                      ],
                      on: {
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.value,
                            "BodyType",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    _vm._l(
                      _vm.PartsCatalogBodyTypeEnum,
                      function (BodyType, propertyName, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: propertyName } },
                          [_vm._v(" " + _vm._s(BodyType) + " ")]
                        )
                      }
                    ),
                    0
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("hr"),
        _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.onFilterClick },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
                _c("span", [_vm._v("Filter")]),
              ]
            ),
          ]),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onResetClick } },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                ]),
                _c("span", [_vm._v("Reset")]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }